if (!customElements.get('greeting-field')) {
  class GreetingField extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.checkboxes = this.querySelectorAll('[data-gift-checkbox]');
      this.fields = this.querySelector('[data-gift-fields]');
      this.propertyInputs = this.querySelectorAll('[data-gift-property]');

      if (window.giftMessagePersistence) window.giftMessagePersistence.register(this);

      this.checkboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', this.handleGiftChange.bind(this));
      });
      this.propertyInputs.forEach((input) => {
        input.addEventListener('input', this.syncAttributes.bind(this));
      });
    }

    handleGiftChange(evt) {
      const checkbox = evt.currentTarget;
      const wrapper = checkbox.closest('[data-gift-wrapper]');
      const index = wrapper.dataset.giftIndex;
      const giftIdInput = this.querySelector(`[data-gift-id][data-gift-index="${index}"]`);

      wrapper.classList.toggle('checked', checkbox.checked);
      if (giftIdInput) giftIdInput.disabled = !checkbox.checked;

      if (index === '1' && this.fields) {
        this.fields.hidden = !checkbox.checked;
        this.propertyInputs.forEach((input) => {
          input.required = checkbox.checked;
          input.disabled = !checkbox.checked;
          if (!checkbox.checked) input.value = '';
        });
        if (!checkbox.checked) this.syncAttributes();
      }

      this.dispatchEvent(new CustomEvent('greeting:change', {
        bubbles: true,
        detail: { index, selected: checkbox.checked }
      }));
    }

    syncAttributes() {
      this.dispatchEvent(new CustomEvent('greeting:change', { bubbles: true }));
    }

    getSelectedItems() {
      return Array.from(this.querySelectorAll('[data-gift-id]:not([disabled])')).map((input) => {
        const item = {
          id: Number(input.value),
          quantity: 1,
          title: input.dataset.productTitle,
          variantTitle: input.dataset.variantTitle,
          price: Number(input.dataset.price)
        };

        return item;
      });
    }

    getAttributes() {
      const attributes = {};
      this.propertyInputs.forEach((input) => {
        if (!input.disabled) attributes[input.dataset.giftProperty] = input.value;
      });
      return attributes;
    }

    reportValidity() {
      return Array.from(this.propertyInputs).every((input) => input.reportValidity());
    }

    markItemsAdded() {
      const cardWasAdded = Boolean(this.querySelector('[data-gift-id][data-gift-index="1"]:not([disabled])'));
      this.querySelectorAll('[data-gift-id]:not([disabled])').forEach((input) => {
        input.disabled = true;
        const wrapper = this.querySelector(`[data-gift-wrapper][data-gift-index="${input.dataset.giftIndex}"]`);
        const checkbox = wrapper?.querySelector('[data-gift-checkbox]');
        if (checkbox) checkbox.disabled = true;
        if (wrapper) wrapper.hidden = true;
      });
      if (cardWasAdded && window.giftMessagePersistence) {
        return window.giftMessagePersistence.markCardAdded(this);
      }
      return Promise.resolve({ skipped: true });
    }
  }

  customElements.define('greeting-field', GreetingField);
}
